import { ReactElement } from "react";
import styled from "styled-components";
import { ElementProps } from "../../functionalComponents/RenderPage";

const StyledPageDivider = styled.div``;

const PageDivider = function(): ReactElement<ElementProps> {
  return <StyledPageDivider className="page-divider"></StyledPageDivider>;
};

export default PageDivider;
